import { graphql } from 'react-relay';
export const ActivePageCommentQuery = graphql`
	query ActivePageCommentQuery($commentId: ID!, $contentId: ID!) {
		comments(commentId: $commentId) {
			nodes {
				id
				ancestors {
					id
				}
				author {
					type
					displayName
					profilePicture {
						path
					}
					... on KnownUser {
						accountId
						permissionType
					}
				}
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				contentStatus
				createdAt {
					value
				}
				createdAtNonLocalized
				links {
					webui
				}
				location {
					type
					... on InlineComment {
						inlineMarkerRef
						inlineText
						inlineResolveProperties {
							isDangling
							resolvedTime
							resolvedFriendlyDate
							resolvedUser
							resolved
						}
					}
					... on FooterComment {
						commentResolveProperties {
							resolvedTime
							resolvedFriendlyDate
							resolvedUser
							resolved
						}
					}
				}
				parentId
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					friendlyWhen
					number
					when
					by {
						type
						displayName
						... on KnownUser {
							accountId
						}
					}
				}
				reactionsSummary(pageId: $contentId, contentType: "page", childType: "comment") {
					ari
					containerAri
					reactionsCount
					reactionsSummaryForEmoji {
						id
						emojiId
						count
						reacted
					}
				}
				replies {
					id
					author {
						type
						... on KnownUser {
							accountId
							permissionType
						}
					}
					createdAt {
						value
					}
					createdAtNonLocalized
					parentId
				}
			}
		}
	}
`;
